/* eslint-disable */
import classNames from 'classnames';
import ErrorIcon from 'images/info-circle-red.svg';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from './TabsButton.module.scss';
const TabsButton = ({ size = 'm', tabs, activeTab, onClick }) => {
    const params = useParams();
    const wrapperRef = useRef(null);
    const innerRef = useRef(null);
    const itemRefs = useRef([]);
    const isMounted = useRef(false);
    const [indicatorStyle, setIndicatorStyle] = useState({ opacity: 0 });
    const handleOnClick = (e, id) => {
        const clickedItem = e.currentTarget;
        const wrapper = wrapperRef.current;
        if (wrapper && clickedItem) {
            const itemOffsetLeft = clickedItem.offsetLeft - 60;
            wrapper.scrollTo({
                left: itemOffsetLeft,
                behavior: 'smooth',
            });
        }
        onClick(id);
    };
    useEffect(() => {
        const activeId = activeTab || params.tab;
        const activeIndex = tabs.findIndex((tab) => tab.id === activeId);
        const activeEl = itemRefs.current[activeIndex];
        if (!activeEl || !innerRef.current) {
            setIndicatorStyle((s) => (Object.assign(Object.assign({}, s), { opacity: 0 })));
            return;
        }
        const rafId = requestAnimationFrame(() => {
            if (!innerRef.current || !activeEl)
                return;
            const listRect = innerRef.current.getBoundingClientRect();
            const itemRect = activeEl.getBoundingClientRect();
            if (itemRect.width === 0)
                return;
            setIndicatorStyle(Object.assign({ opacity: 1, transform: `translateX(${itemRect.left - listRect.left}px)`, width: itemRect.width }, (isMounted.current ? {} : { transition: 'none' })));
            isMounted.current = true;
        });
        return () => cancelAnimationFrame(rafId);
    }, [activeTab, params.tab, tabs]);
    return (React.createElement("div", { ref: wrapperRef, className: styles.wrap },
        React.createElement("div", { ref: innerRef, className: classNames(styles.inner, styles[size]) },
            React.createElement("div", { className: styles.indicator, style: indicatorStyle }),
            tabs.map((tab, index) => (React.createElement("button", { key: index, ref: (el) => {
                    itemRefs.current[index] = el;
                }, className: classNames(styles.tab, styles[size], {
                    [styles.active]: tab.id === activeTab || tab.id === params.tab,
                    [styles.squared]: tab.squared === true,
                }), onClick: (e) => handleOnClick(e, tab.id) },
                tab.icon && tab.icon,
                tab.label && React.createElement("p", null, tab.label),
                tab.error && React.createElement(ErrorIcon, null),
                tab.counter && React.createElement("span", { className: styles.counter }, tab.counter)))))));
};
export default TabsButton;
